import {
  DEFAULT_LOCALE,
  isLocale,
  splitLocale,
  type Locale,
} from "@lib/i18n/locale";
import { useRouter as useCompatRouter } from "next/compat/router";
import { useParams } from "next/navigation";

/**
 * The locale of the current route, in either router. The Pages Router reads it from the
 * visible path: its `query.locale` is not reliable for German URLs, see `useRouter`.
 */
const useRouteLocale = (): Locale => {
  const pagesRouter = useCompatRouter();
  const params = useParams();

  if (pagesRouter) {
    return splitLocale(pagesRouter.asPath ?? "/").locale;
  }

  const locale = params?.locale;

  return typeof locale === "string" && isLocale(locale)
    ? locale
    : DEFAULT_LOCALE;
};

export default useRouteLocale;
